/* PANDA FOOD 2.0, page shell.
   Two jobs no single section can do, because both are about how
   sections meet each other. */
(function () {
  'use strict';

  /* 1. How tall the announcement bar is. The header sticks directly
     beneath it, and the height differs between desktop and mobile,
     so measure it rather than hard-code a number. */
  function measureBar() {
    var bar = document.querySelector('.pf2-announce');
    var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--pf2-announce-h', h + 'px');
  }

  /* 2. Painting the wavy section edges in the colour of the band they
     run into, so the two meet with no seam.

     Read the neighbour's FIRST ELEMENT CHILD, which is the band's own
     root. Two wrong answers sit either side of this:

       - the Shopify section wrapper is painted white by the base theme,
         so asking the wrapper returns white and leaves a white stripe;
       - searching the whole subtree finds the first painted thing at any
         depth, which was the footer's yellow newsletter button.

     The band root is the only element that carries the band colour. */
  function painted(bg) {
    return !!bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent';
  }

  function bandBg(wrapper) {
    var root = wrapper.firstElementChild;
    if (!root) return '';
    var bg = getComputedStyle(root).backgroundColor;
    return painted(bg) ? bg : '';
  }

  function neighbourBg(section, dir) {
    var wrap = section.closest('.shopify-section') || section.parentElement;
    if (!wrap) return '';
    var sib = dir === 'prev' ? wrap.previousElementSibling : wrap.nextElementSibling;
    while (sib) {
      var bg = bandBg(sib);
      if (bg) return bg;
      sib = dir === 'prev' ? sib.previousElementSibling : sib.nextElementSibling;
    }
    return '';
  }

  var EDGES = [
    { sel: '.pf2-story-edge--top svg',    dir: 'prev' },
    { sel: '.pf2-story-edge--bottom svg', dir: 'next' },
    { sel: '.pf2-pdp-edge svg',           dir: 'next' },
    { sel: '.pf2-hero-edge svg',          dir: 'next' }
  ];

  function paintEdges() {
    EDGES.forEach(function (edge) {
      document.querySelectorAll(edge.sel).forEach(function (svg) {
        var host = svg.closest('section') || svg.parentElement;
        if (!host) return;
        var bg = neighbourBg(host, edge.dir);
        if (bg) svg.style.fill = bg;
      });
    });
  }

  function run() { measureBar(); paintEdges(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  addEventListener('load', run);
  addEventListener('resize', run, { passive: true });
})();
